import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { OfferSkeleton } from '../components';
import { pageStatusSelector } from '../store';
import OfferErrorRenderer from './OfferErrorRenderer';

function OfferPagesRenderer() {
    const status = useSelector(pageStatusSelector);

    switch (status) {
        case 'error':
            return <OfferErrorRenderer />;
        case 'success':
            return <Outlet />;
        case 'idle':
        case 'pending':
            return <OfferSkeleton />;
    }
}

export default memo(OfferPagesRenderer);
